import { render } from "./Cliente.vue?vue&type=template&id=dd9b4286"
import script from "./Cliente.vue?vue&type=script&lang=ts"
export * from "./Cliente.vue?vue&type=script&lang=ts"
script.render = render

export default script